var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{class:_vm.$style['search'],on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('InputLightSearch',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value},on:{"input":_vm.input}}),_c('VButton',{staticClass:"button_green",class:_vm.$style['search__button']},[_vm._v("Поиск")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }